import { post } from '../graphql.js';

export async function fetchHistoricalRates(interval) {
  const intervalArgument = interval ? '(interval: $interval)' : '';

  const intervalInSeconds =
    interval === null ? null : Math.round(interval / 1000);

  const intervalVar =
    intervalInSeconds !== null ? `($interval: Int = ${intervalInSeconds})` : '';

  const { data } = await post(
    `
    query Rates${intervalVar}{
      root {
        hf_historical_rates{
          rates5years${intervalArgument}{ 
            time
            value 
          }
          rates10years${intervalArgument}{ 
            time
            value 
          }
          rates15years${intervalArgument}{ 
            time
            value 
          }
          rates20years${intervalArgument}{ 
            time
            value 
          }
          bunds10y_yields${intervalArgument}{ 
            time
            value 
          }
        }
      }
    }
  `,
    false,
    'fetchHistoricalRates',
  );
  if (!data?.data?.root?.hfHistoricalRates) {
    throw new Error('Unable to retrieve historical rates');
  }

  return data.data.root.hfHistoricalRates;
}
